import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getDigilockerDetails } from "../../waitlist/services/waitlist-service";
import Digilocker from "./Digilocker";
import KycAdressContentNew from "./KycAdressContentNew";
import { utils } from "../../core/helpers/utils";

export default function ChooseAddressProof(props) {
  const [digilockerOption, setDigilockerOption] = useState({});
  const [isManually, setisManually] = useState(false);

  const redirectToDigio = () => {
    const header = {
        "X-product": `orobonds:default`,
      };
      getDigilockerDetails(header).then((result) => {
        const response = utils.parsePayload(result);
        if (!response || !response.success || !response.data) {
          return toast.error(response.message || "Error: Not able to fetch details of digilocker");
        }
        setDigilockerOption({ ...response.data });
        window.location.href = response.data.kycRedirectionUrl;
      });
  };

  const uploadManually = () => {
    setisManually(true);
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-100">
      {!isManually ? (
        <Digilocker
          redirectToDigio={redirectToDigio}
          uploadManually={uploadManually}
          isDigioEnabled={props?.thirdpartyData?.data?.isDigioEnabled}
        />
      ) : (
        <KycAdressContentNew
          pan={props.panValue}
          email={props.email}
          setReupload={props.setReupload}
          moveNextTab={props.moveNextTab}
          areAllDocsUploaded={props.areAllDocsUploaded}
          userProfile={props.userProfile}
          thirdpartyData={props.thirdpartyData}
          updateDocStatus={props.updateDocStatus}
          uploadedDocs={props.uploadedDocs}
          product={props.product}
          errors={props.errors}
        />
      )}
      <ToastContainer />
    </div>
  );
}
